import { connect } from 'react-redux'
import PlanChangeTable from '../components/PlanChangeTable'

const mapStateToProps = (state, ownProps) => {
    return {
        rows: state.optionPricing.optionRows
    }
}

const PlanChangeTableContainer = connect(
    mapStateToProps
)(PlanChangeTable)

export default PlanChangeTableContainer